<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{('successPayment.title') | translate}}</app-view-title>
  <div class="scroll_wrapper">
    <div class="parent-container">
      <app-view-deco-image class="mt_20 mb_20" imageUrl="assets-projects/images/image_done.svg"></app-view-deco-image>
<!--
      <qrcode *ngIf="qr.qrCode" class="f_center mb_20" [qrdata]="qr.qrCode" [width]="300" [errorCorrectionLevel]="'M'" allowEmptyString="true"></qrcode>
-->
      <div class="mb_40 successPayment-text">
        <p> {{'successPayment.description1' | translate}}</p>
        <p> {{'successPayment.description2' | translate}}</p>
      </div>
    </div>
    <div class="btns-container">
      <div class="fullWidth flex f_center">
        <div class="menuButton-container flex f_center">
          <div class="ml_10 fullWidth">
            <div *ngIf="api.userRole.isCustomer">
              <app-button *ngIf="paymentId && qr.qrCode" size="xsm" class="resp_minSize_l fullWidth mb_10" (btnClicked)="printA4()">{{'global.print' | translate}}</app-button>
              <app-button *ngIf="paymentId && qr.qrCode" class="resp_maxSize_l fullWidth mb_10" (btnClicked)="printA4()">{{'global.print' | translate}}</app-button>
            </div>
            <app-button [initStartDebounce]="api.userRole.isKiosk ? true : false" [showRemainingDebounceTime]="api.userRole.isKiosk ? true : false" [debounceTimeInMilliseconds]="debounceTimer" size="xsm" color="transparent" border="true" formId="form" class="resp_minSize_l fullWidth" (btnClicked)="nav.to('dashboard')">{{'global.close' | translate}}</app-button>

            <app-button color="transparent" border="true" formId="form" class=" resp_maxSize_l fullWidth" (btnClicked)="nav.to('dashboard')">{{'global.back' | translate}}</app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-print *ngIf="qr.currentQrData"></app-print>
